<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners" @close="close" class="presee-bd">
    <div class="dialog-body presee-bd">
      <div class="information-body">
        <p class="title">{{ info.title }}</p>
        <div class="content" v-html="info.content">{{ info.content }}</div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="timer">
        <i class="icon icon-shijian"></i>
        <span>{{ info.gmtModified }}</span>
      </div>
      <div class="reading">
        <i class="icon icon-yanjing"></i>
        <span>{{ info.readedCount }}</span>
      </div>
      <el-checkbox v-model="haveRead" :disabled="model.type === 'preSee'">
        {{ $t('base_notice_preSee_dialog.yi_du_bu_zai_ti_shi') }}
      </el-checkbox>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      info: {
        title: '',
        beginTime: '',
        endTime: '',
        isPop: '',
        state: '',
        publishTime: '',
        content: '',
        pushChannelName: '',
        pushRoleName: '',
        pushRangeName: '',
        creator: '',
        gmtCreate: ''
      },
      haveRead: false
    };
  },
  mounted() {
    this.getNoticeInfo();
  },
  methods: {
    // 初始化
    getNoticeInfo: function () {
      this.$getJSON(`${apis.noticeInfo}/${this.model.id}`).then((res) => {
        this.info = res.data;
        this.info.content = this.info.content.replace(/(\r\n|\n|\r)/g, '<br />');
      });
    },
    // 关闭弹窗
    close: function () {
      if (this.haveRead) {
        this.$postJSON(`${apis.noticeReaded}/${this.model.id}`, true).then(() => {
          this.visible = false;
        });
      } else {
        this.visible = false;
      }
    }
  }
};
</script>

<style lang="scss">
.presee-bd {
  .information-body {
    .title {
      font-size: 12px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 12px;
      padding-bottom: 8px;
    }
    .content {
      font-size: 12px;
      color: rgba(108, 117, 125, 1);
      line-height: 22px;
    }
    .el-row {
      color: #262626;
      margin-bottom: 12px;
      line-height: 17px;
      font-size: 12px;
      > .el-col {
        text-align: left;
        color: #6e6e6e;
        span {
          padding-left: 15px;
          color: #262626;
        }
      }
      > .el-col:last-child {
        text-align: right;
        padding-right: 15px;
      }
    }
  }
  .el-dialog__footer {
    padding: 11px 24px !important;
    box-shadow: 0px -1px 0px 0px rgba(233, 235, 236, 1);
    .timer,
    .reading {
      font-size: 12px;
      color: rgba(108, 117, 125, 1);
      float: left;
      line-height: 19px;
      i {
        margin-right: 10px;
      }
    }
    .reading {
      margin-left: 20px;
    }
  }
}
</style>
